import * as BlogSettingActionTypes from '../constants/setting/blog'
import { RECEIVE_SKIN_INFO } from '../constants/design/SkinActionTypes'
import update from 'immutability-helper'

const initialState = window.Config.blog

export default (state = initialState, action) => {
  switch (action.type) {
    case BlogSettingActionTypes.RECEIVE_INFO:
      return update(state, {
        image: {
          $set: action.info.logoUrl
        },
        title: {
          $set: action.info.title
        }
      })

    case BlogSettingActionTypes.CHANGE_ADDRESS:
      return update(state, {
        domain: {
          $set: action.address.useSecondaryDomain? action.address.secondaryDomain : action.address.primaryDomain
        }
      })
    case BlogSettingActionTypes.CHANGE_USE_COMMENT_RECOGNITION:
      return update(state, {
        blogSettings : {
          useCommentRecognition : {
            $set : action.useCommentRecognition
          }
        }
      })
    case BlogSettingActionTypes.CHANGE_ACTIVE_PLUGINS:
      if (action.plugin.active)
        return update(state, {
          activePlugins : {
            $push : [action.plugin.name]
          }
        })
      else {
        let index = state.activePlugins.indexOf(action.plugin.name)
        if (index != -1) {
          return update(state, {
            activePlugins: {
              $splice: [[index, 1]]
            }
          })
        }
        return state
      }
    case RECEIVE_SKIN_INFO:
      return update(state, {
        skinInfo: {
          $set: action.skinInfo
        }
      })
    default:
      return state
  }
}
